import { PostContextType, PostStateProps } from "./types";

export const defaultValues: PostContextType = {
  postState: {
    posts: undefined,
    selectedSmartGoal: undefined,
    groups: [],
  },
  updateState: (_newState: Partial<PostStateProps>) => null,
  fetchPosts: (_id: string) => null,
};
